module.exports = __webpack_public_path__ + "img/199.2892bc75.jpg";